import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DestinyCreateDto, DestinyDto, DestinyExcelDownloadDto, DestinyUpdateDto, GetDestiniesInputDto } from '../dtos/destiny/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class DestinyService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: DestinyCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DestinyDto>({
      method: 'POST',
      url: '/api/planning/destinies',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/destinies/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/destinies',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DestinyDto>({
      method: 'GET',
      url: `/api/planning/destinies/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/destinies/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetDestiniesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<DestinyDto>>({
      method: 'GET',
      url: '/api/planning/destinies',
      params: { name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: DestinyExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/destinies/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DestinyDto[]>({
      method: 'GET',
      url: '/api/planning/destinies/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: DestinyUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DestinyDto>({
      method: 'PUT',
      url: `/api/planning/destinies/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}